export enum Environment {
  Development = 'development',
  Local = 'local',
  Production = 'production',
  Test = 'test',
}
